import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { FaArrowRight } from 'react-icons/fa'
import { useBusinessContext } from '@root/context'
import { getSettingsPageUrl } from '@root/constants'
import { Link } from 'react-router-dom'

interface Props {
  text: string
  icon: React.ReactNode
  iconText: string
  ctaLabel?: string
  ctaTo?: string
}

export const InlineTeaserView: React.FC<Props> = ({ text, icon, iconText, ctaLabel, ctaTo }) => {
  const [t] = useTranslation()

  const { slug } = useBusinessContext()
  const planSettingsUrl = getSettingsPageUrl(slug, { page: 'plan' })
  const targetUrl = ctaTo || planSettingsUrl
  const label = ctaLabel || t('inlineTeaser.startTrial')

  return (
    <StyledContainer>
      <StyledContentWrapper>
        <StyledHeaderContainer>
          <StyledIconWrapper>{icon}</StyledIconWrapper>
          <StyledIconText>{iconText}</StyledIconText>
        </StyledHeaderContainer>
        <StyledText>{text}</StyledText>

        <StyledStretchedButton to={targetUrl}>
          <span>{label}</span> <FaArrowRight />
        </StyledStretchedButton>
      </StyledContentWrapper>
    </StyledContainer>
  )
}

const StyledContainer = styled.div`
  display: flex;
  border: 2px solid ${({ theme }) => theme.colors.primary};
  border-radius: ${({ theme }) => theme.borderRadius.md}rem;
  padding: ${({ theme }) => theme.spacing.md}rem;
  align-items: center;
  justify-content: flex-start;
`

const StyledContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: ${({ theme }) => theme.spacing.sm}rem;
`

const StyledHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm}rem;
`

const StyledIconWrapper = styled.div`
  & > * {
    width: 1.2rem;
    height: 1.2rem;
    color: ${({ theme }) => theme.colors.primary};
  }
`

const StyledIconText = styled.b`
  margin: 0;
  font-size: ${({ theme }) => theme.fontSize.md}rem;
`

const StyledText = styled.p`
  margin: 0;
  font-size: ${({ theme }) => theme.fontSize.md}rem;
`

const StyledStretchedButton = styled(Link)`
  justify-content: center;
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSize.md}rem;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xxs}rem;
  width: fit-content;
`
